module.exports = __webpack_public_path__ + "static/assets/36757247e53c6602f581f8c210d2aff3.png";